import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import { 
  PageIntro,
  FormGroup,
  FormLabel,
  FormInput,
  FormTextArea,
  FormSubmit,
  Form,
} from '../components/StyledComponents'

const ContactPage = () => (
  <div>
    <PageIntro>
      <h1>Contact</h1>
      <p>You can also reach me on Twitter: <a href="https://twitter.com/jbhuer">@jbhuer</a></p>
    </PageIntro>

    <Form acceptCharset="UTF-8" action="https://usebasin.com/f/78d6849a1190" method="POST">
      <FormGroup>
        <FormLabel htmlFor="name">Name</FormLabel>
        <FormInput type="text" className="form-control" id="name" name="name" required="true" />
      </FormGroup>

      <FormGroup>
        <FormLabel htmlFor="email">Email</FormLabel>
        <FormInput type="email" className="form-control" id="email" name="email" required="true" />
      </FormGroup>

      <FormGroup>
        <FormLabel htmlFor="message">Message</FormLabel>
        <FormTextArea className="form-control" id="message" rows="3" name="message"></FormTextArea>
      </FormGroup>

      <FormSubmit type="submit" className="btn btn-primary">Submit →</FormSubmit>
    </Form>
  </div>
)

export default ContactPage


// WEBPACK FOOTER //
// ./src/pages/contact.js